import { endOfDay } from "date-fns";

import { ThreadFiltersInput } from "@megaron/docs-contracts";

import { Filters } from "./useThreadFilters";

type ThreadSearchInputOptions = {
  limit?: number;
  offset?: number;
};

export const buildThreadSearchInput = (filters: Filters, options: ThreadSearchInputOptions = {}): ThreadFiltersInput => ({
  limit: options.limit,
  offset: options.offset,
  searchText: filters.searchText,
  sort: filters.sort,
  status: filters.status,
  signedBy: filters.signedBy,
  budgetUuid: filters.budgetUuid,
  isDigital: filters.isDigital,
  isReceived: filters.isReceived,
  isPosted: filters.isPosted,
  participant: filters.participant,
  isRead: filters.isRead,
  isOverdue: filters.isOverdue,
  isMine: filters.isMine,
  issuer: filters.issuer,
  tags: filters.tags,
  issueDateFrom: filters.issueDateFrom,
  issueDateTo: filters.issueDateTo ? endOfDay(filters.issueDateTo) : undefined,
  receivedDateFrom: filters.receivedDateFrom,
  receivedDateTo: filters.receivedDateTo ? endOfDay(filters.receivedDateTo) : undefined,
  dueDateFrom: filters.dueDateFrom,
  dueDateTo: filters.dueDateTo ? endOfDay(filters.dueDateTo) : undefined,
  approvedAtFrom: filters.approvedAtFrom,
  approvedAtTo: filters.approvedAtTo ? endOfDay(filters.approvedAtTo) : undefined,
});
